<template>
    <Tooltip class="min-w-full" :is-disabled="!Boolean(props.disabledExplanation)">
        <template #trigger="tooltipProps">
            <button
                type="button"
                class="flex flex-row items-center gap-1 rounded-lg font-semibold w-full justify-center py-2 focus-visible:outline-hidden focus-visible:ring-3 focus-visible:ring-offset-2"
                :aria-disabled="props.status === 'Pending' || Boolean(props.disabledExplanation)"
                :class="{
                    'bg-gray-300 hover:bg-gray-600 active:bg-gray-800 text-gray-700 hover:text-gray-50 active:text-gray-50 cursor-pointer focus-visible:ring-gray-700 ':
                        props.status === 'Default' && !Boolean(props.disabledExplanation),
                    'bg-gray-300 text-gray-500 cursor-progress focus-visible:ring-gray-500':
                        props.status === 'Pending' && !Boolean(props.disabledExplanation),
                    'bg-red-700 hover:bg-red-800 active:bg-red-900 cursor-pointer text-red-50 focus-visible:ring-red-700 ':
                        props.status === 'Error' && !Boolean(props.disabledExplanation),
                    'bg-gray-300 text-gray-500 cursor-not-allowed focus-visible:ring-gray-500': Boolean(
                        props.disabledExplanation,
                    ),
                }"
                v-bind="tooltipProps"
                @click="Boolean(props.disabledExplanation) ? undefined : emit('click')"
            >
                <PlusIcon v-if="props.status === 'Default'" class="size-5" />
                <PendingIcon v-if="props.status === 'Pending'" class="size-5 animate-spin" />
                <RefreshIcon v-if="props.status === 'Error'" class="size-5" />

                <span v-if="props.status === 'Default'">
                    {{ $t('inline-create-allocation-variant-new-allocation-variant') }}
                </span>

                <span v-else-if="props.status === 'Pending'">
                    {{ $t('inline-create-allocation-variant-creating-allocation-variant') }}
                </span>

                <span v-else-if="props.status === 'Error'">
                    {{ $t('inline-create-allocation-variant-error-creating-allocation-variant') }}
                </span>
            </button>
        </template>

        <template #text>
            {{ props.disabledExplanation }}
        </template>
    </Tooltip>
</template>

<script setup lang="ts">
import PendingIcon from '../Icon/PendingIcon.vue';
import PlusIcon from '../Icon/PlusIcon.vue';
import RefreshIcon from '../Icon/RefreshIcon.vue';
import Tooltip from '../Tooltip/Tooltip.vue';

export type InlineCreateAllocationVariantProps = {
    status: 'Default' | 'Pending' | 'Error';
    disabledExplanation?: string;
};

type InlineCreateAllocationVariantEmits = {
    (e: 'click'): void;
};

const props = defineProps<InlineCreateAllocationVariantProps>();
const emit = defineEmits<InlineCreateAllocationVariantEmits>();
</script>
